import HistoryLog from "@/lib/historyLog";
import { reportHomeQueryParams } from "@/lib/queryParams/reportHomeQueryParams";
import { thgQueryParams } from "@/lib/queryParams/thgQueryParams";
import { LoginModule } from "@/store/modules/login.store";
import { UserModule } from "@/store/modules/me-user.store";
import Vue from "vue";
import { NavigationGuard } from "vue-router";

/**
 * Navigation guard that checks route-level permissions.
 * Reads the `permission` property from `to.meta.permission` (set by enrichRouteMeta).
 * Only applies permission checks on routes that define a permission.
 * Checks if user is authenticated since the guard is permission-based.
 */
export const permissionGuard: NavigationGuard = (to, from, next) => {
  // keep track of navigation history
  HistoryLog.add(to.path);

  try {
    thgQueryParams.forEach((param) => {
      const value = to.query[param.key];

      if (value !== undefined) {
        param.onFound((value as string) || "");
        Vue.$log.warn(`${param.key} set in store`);
      }
    });

    reportHomeQueryParams.forEach((param) => {
      const value = to.query[param.key];

      if (value !== undefined) {
        param.onFound((value as string) || "");
        Vue.$log.warn(`${param.key} set in store`);
      }
    });
  } catch (e) {
    Vue.$log.error(e);
  }

  const permission = to.meta?.permission;

  if (!permission) {
    Vue.$log.info("no rule");
    return next();
  }
  Vue.$log.info(permission);

  Vue.$log.info("User logged in?");
  if (!UserModule.isAuthenticated) {
    //Save where user wanted to go so that user can be redirected back after login
    LoginModule.setRedirect(to.fullPath);

    Vue.$log.info("Login redirect");
    return next({ name: "Login" });
  }

  Vue.$log.info("User logged in! Access?");
  if (UserModule.abilities.cannot(permission.action, permission.resource)) {
    Vue.$log.info("Permission insufficient");
    return next({
      name: "Unauthorized",
      params: { action: permission.action, subject: permission.resource }
    });
  }

  Vue.$log.info("All good");
  return next();
};
